import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {VersionsViewDetails} from '@mintdata-wsp/wsp/ui/views/visualDesigner/surface/panels/versions/VersionsViewDetails';
import {VersionsViewDiff} from '@mintdata-wsp/wsp/ui/views/visualDesigner/surface/panels/versions/VersionsViewDiff';
import {VersionsViewHeader,} from '@mintdata-wsp/wsp/ui/views/visualDesigner/surface/panels/versions/VersionsViewHeader';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./VersionsView.less');
const cx = classnames.bind(styles);

export enum VersionsViewType
{
    DIFF = 'diff',
    DETAILS = 'details',
}

@observer
export class VersionsView extends React.Component<any, any>
{
    public render():JSX.Element
    {
        const dvc = controllers.ui.designVersions;

        const isVersionsPanelVisible = dvc.isVersionsPanelVisible();

        const isDiffVisible = dvc.isDiffVisible();
        const isDetailsVisible = dvc.isDetailsVisible();

        const type = isDiffVisible ? VersionsViewType.DIFF : VersionsViewType.DETAILS;

        return (
            <div className={cx('base', {isVisible: isVersionsPanelVisible})}>

                <VersionsViewHeader type={type} />

                {
                    isDiffVisible &&
                    <VersionsViewDiff />
                }
                {
                    isDetailsVisible &&
                    <VersionsViewDetails />
                }

            </div>
        );
    }
}
